import { getAccessToken } from '../authentication/supabaseService';
import { SetupReviewError } from './inventorySetupReviewService';
import type { ExcelSetupCatalogue, ExcelSetupCommit, ExcelSetupPreview } from './inventoryExcelSetupTypes';

async function request<T>(restaurantId: string, suffix: string, body?: FormData | ExcelSetupCommit): Promise<T> {
  const token = await getAccessToken();
  const multipart = body instanceof FormData;
  const response = await fetch('/api/inventory/setup-review/' + encodeURIComponent(restaurantId) + '/excel' + suffix, {
    method: body ? 'POST' : 'GET',
    headers: { Authorization: 'Bearer ' + token, ...(!multipart ? { 'Content-Type': 'application/json' } : {}) },
    ...(body ? { body: multipart ? body : JSON.stringify(body) } : {}),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new SetupReviewError(error.error ?? 'request_failed', response.status);
  }
  return response.json();
}

export const fetchExcelSetupCatalogue = (restaurantId: string) => request<ExcelSetupCatalogue>(restaurantId, '');
export const previewInventoryExcelSetup = (restaurantId: string, file: File, sheetScope: 'first' | 'drinks') => {
  const body = new FormData();
  body.append('file', file); body.append('sheetScope', sheetScope);
  return request<ExcelSetupPreview>(restaurantId, '/preview', body);
};
export const saveInventoryExcelSetup = (restaurantId: string, input: ExcelSetupCommit) =>
  request<{ productsAdded: number; assignmentsCreated: number }>(restaurantId, '/commit', input);
